/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaxeCommandDto } from './TaxeCommandDto';
import {
    TaxeCommandDtoFromJSON,
    TaxeCommandDtoFromJSONTyped,
    TaxeCommandDtoToJSON,
    TaxeCommandDtoToJSONTyped,
} from './TaxeCommandDto';
import type { BorneDto } from './BorneDto';
import {
    BorneDtoFromJSON,
    BorneDtoFromJSONTyped,
    BorneDtoToJSON,
    BorneDtoToJSONTyped,
} from './BorneDto';
import type { ReAssureurCommandDto } from './ReAssureurCommandDto';
import {
    ReAssureurCommandDtoFromJSON,
    ReAssureurCommandDtoFromJSONTyped,
    ReAssureurCommandDtoToJSON,
    ReAssureurCommandDtoToJSONTyped,
} from './ReAssureurCommandDto';
import type { CoAssureurCommandDto } from './CoAssureurCommandDto';
import {
    CoAssureurCommandDtoFromJSON,
    CoAssureurCommandDtoFromJSONTyped,
    CoAssureurCommandDtoToJSON,
    CoAssureurCommandDtoToJSONTyped,
} from './CoAssureurCommandDto';
import type { TarifCommandDto } from './TarifCommandDto';
import {
    TarifCommandDtoFromJSON,
    TarifCommandDtoFromJSONTyped,
    TarifCommandDtoToJSON,
    TarifCommandDtoToJSONTyped,
} from './TarifCommandDto';

/**
 * Ajout d'une garantie au tunnel.
 * @export
 * @interface CreateGarantieTunnelCommand
 */
export interface CreateGarantieTunnelCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    tunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    garantieId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGarantieTunnelCommand
     */
    isRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    designation: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    descriptionCourte?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    descriptionLongue?: string | null;
    /**
     * Colonne « Franchise » du tableau des garanties des documents : HTML libre avec jetons {{CODE}} des variables du tunnel, résolus par dossier à la génération. Vide = texte par défaut du produit.
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    franchiseDetail?: string | null;
    /**
     * Colonne « Plafond » du tableau des garanties des documents, même mécanique.
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    plafondDetail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    iconeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateGarantieTunnelCommand
     */
    ordreAffichage?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    garantieParentId?: string | null;
    /**
     * 
     * @type {TarifCommandDto}
     * @memberof CreateGarantieTunnelCommand
     */
    tarification: TarifCommandDto;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof CreateGarantieTunnelCommand
     */
    franchises?: Array<BorneDto>;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof CreateGarantieTunnelCommand
     */
    plafonds?: Array<BorneDto>;
    /**
     * Compagnie porteur de risque principale (PersonneMorale de nature CIE).
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    assureurPersonneMoraleId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGarantieTunnelCommand
     */
    compteBancaireId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateGarantieTunnelCommand
     */
    tauxQP?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGarantieTunnelCommand
     */
    aperition?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateGarantieTunnelCommand
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateGarantieTunnelCommand
     */
    dateFin?: Date | null;
    /**
     * 
     * @type {TaxeCommandDto}
     * @memberof CreateGarantieTunnelCommand
     */
    taxeProfessionelle?: TaxeCommandDto;
    /**
     * 
     * @type {TaxeCommandDto}
     * @memberof CreateGarantieTunnelCommand
     */
    taxeParticulier?: TaxeCommandDto;
    /**
     * 
     * @type {Array<CoAssureurCommandDto>}
     * @memberof CreateGarantieTunnelCommand
     */
    coAssureurs?: Array<CoAssureurCommandDto>;
    /**
     * 
     * @type {Array<ReAssureurCommandDto>}
     * @memberof CreateGarantieTunnelCommand
     */
    reAssureurs?: Array<ReAssureurCommandDto>;
}

/**
 * Check if a given object implements the CreateGarantieTunnelCommand interface.
 */
export function instanceOfCreateGarantieTunnelCommand(value: object): value is CreateGarantieTunnelCommand {
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('garantieId' in value) || value['garantieId'] === undefined) return false;
    if (!('designation' in value) || value['designation'] === undefined) return false;
    if (!('tarification' in value) || value['tarification'] === undefined) return false;
    if (!('assureurPersonneMoraleId' in value) || value['assureurPersonneMoraleId'] === undefined) return false;
    if (!('compteBancaireId' in value) || value['compteBancaireId'] === undefined) return false;
    return true;
}

export function CreateGarantieTunnelCommandFromJSON(json: any): CreateGarantieTunnelCommand {
    return CreateGarantieTunnelCommandFromJSONTyped(json, false);
}

export function CreateGarantieTunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGarantieTunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'tunnelId': json['tunnelId'],
        'garantieId': json['garantieId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'designation': json['designation'],
        'descriptionCourte': json['descriptionCourte'] == null ? undefined : json['descriptionCourte'],
        'descriptionLongue': json['descriptionLongue'] == null ? undefined : json['descriptionLongue'],
        'franchiseDetail': json['franchiseDetail'] == null ? undefined : json['franchiseDetail'],
        'plafondDetail': json['plafondDetail'] == null ? undefined : json['plafondDetail'],
        'iconeId': json['iconeId'] == null ? undefined : json['iconeId'],
        'ordreAffichage': json['ordreAffichage'] == null ? undefined : json['ordreAffichage'],
        'garantieParentId': json['garantieParentId'] == null ? undefined : json['garantieParentId'],
        'tarification': TarifCommandDtoFromJSON(json['tarification']),
        'franchises': json['franchises'] == null ? undefined : ((json['franchises'] as Array<any>).map(BorneDtoFromJSON)),
        'plafonds': json['plafonds'] == null ? undefined : ((json['plafonds'] as Array<any>).map(BorneDtoFromJSON)),
        'assureurPersonneMoraleId': json['assureurPersonneMoraleId'],
        'compteBancaireId': json['compteBancaireId'],
        'tauxQP': json['tauxQP'] == null ? undefined : json['tauxQP'],
        'aperition': json['aperition'] == null ? undefined : json['aperition'],
        'dateDebut': json['dateDebut'] == null ? undefined : (new Date(json['dateDebut'])),
        'dateFin': json['dateFin'] == null ? undefined : (new Date(json['dateFin'])),
        'taxeProfessionelle': json['taxeProfessionelle'] == null ? undefined : TaxeCommandDtoFromJSON(json['taxeProfessionelle']),
        'taxeParticulier': json['taxeParticulier'] == null ? undefined : TaxeCommandDtoFromJSON(json['taxeParticulier']),
        'coAssureurs': json['coAssureurs'] == null ? undefined : ((json['coAssureurs'] as Array<any>).map(CoAssureurCommandDtoFromJSON)),
        'reAssureurs': json['reAssureurs'] == null ? undefined : ((json['reAssureurs'] as Array<any>).map(ReAssureurCommandDtoFromJSON)),
    };
}

export function CreateGarantieTunnelCommandToJSON(json: any): CreateGarantieTunnelCommand {
    return CreateGarantieTunnelCommandToJSONTyped(json, false);
}

export function CreateGarantieTunnelCommandToJSONTyped(value?: CreateGarantieTunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tunnelId': value['tunnelId'],
        'garantieId': value['garantieId'],
        'isRequired': value['isRequired'],
        'designation': value['designation'],
        'descriptionCourte': value['descriptionCourte'],
        'descriptionLongue': value['descriptionLongue'],
        'franchiseDetail': value['franchiseDetail'],
        'plafondDetail': value['plafondDetail'],
        'iconeId': value['iconeId'],
        'ordreAffichage': value['ordreAffichage'],
        'garantieParentId': value['garantieParentId'],
        'tarification': TarifCommandDtoToJSON(value['tarification']),
        'franchises': value['franchises'] == null ? undefined : ((value['franchises'] as Array<any>).map(BorneDtoToJSON)),
        'plafonds': value['plafonds'] == null ? undefined : ((value['plafonds'] as Array<any>).map(BorneDtoToJSON)),
        'assureurPersonneMoraleId': value['assureurPersonneMoraleId'],
        'compteBancaireId': value['compteBancaireId'],
        'tauxQP': value['tauxQP'],
        'aperition': value['aperition'],
        'dateDebut': value['dateDebut'] == null ? undefined : ((value['dateDebut'] as any).toISOString()),
        'dateFin': value['dateFin'] == null ? undefined : ((value['dateFin'] as any).toISOString()),
        'taxeProfessionelle': TaxeCommandDtoToJSON(value['taxeProfessionelle']),
        'taxeParticulier': TaxeCommandDtoToJSON(value['taxeParticulier']),
        'coAssureurs': value['coAssureurs'] == null ? undefined : ((value['coAssureurs'] as Array<any>).map(CoAssureurCommandDtoToJSON)),
        'reAssureurs': value['reAssureurs'] == null ? undefined : ((value['reAssureurs'] as Array<any>).map(ReAssureurCommandDtoToJSON)),
    };
}

